import { HubItemCategoryPermissionModel } from "../Hub/hubItemCategories";
import { environmentHttpClient } from "../httpClient";

export type EventCategoryListItemModel = {
	id: number;
	name: string;
	description: string;
	publishedCount: number;
	draftCount: number;
	permissions: HubItemCategoryPermissionModel;
};

export type EventCategoryListModel = {
	canCreateNewCategories: boolean;
	categories: readonly EventCategoryListItemModel[];
};

export async function listCategories(
	signal?: AbortSignal
): Promise<EventCategoryListModel> {
	return environmentHttpClient.get<EventCategoryListModel>(
		"UiApi/EventCategories/List",
		undefined,
		{ signal }
	);
}